export default __webpack_public_path__ + "static/media/logo-default.f72acb4c.svg";